"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const form_1 = require("../../composite/form/form");
const dialog_1 = require("../dialog/dialog");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_field_context_1 = require("./table-field-context");
exports.TableFieldDialog = (0, react_1.forwardRef)(function TableFieldDialog({ index, value, FormFieldsComponent }, dialogRef) {
    const { disabled, saveRow, initNewItem, validationSchema } = (0, react_1.useContext)(table_field_context_1.TableFieldContext);
    const ref = (0, react_1.useRef)(null);
    const handleSubmit = (0, event_callback_hook_1.useEventCallback)((values) => {
        saveRow(index, values);
    });
    const handleSave = (0, event_callback_hook_1.useEventCallback)(async () => {
        var _a, _b;
        const errors = await ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.validateForm());
        if ((errors === null || errors === void 0 ? void 0 : errors.length) === 0) {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.submitForm();
        }
        else {
            return false;
        }
    });
    const title = (react_1.default.createElement(react_1.default.Fragment, null,
        disabled && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_DIALOG_TITLE_DETAIL", defaultMessage: "Detail" })),
        !disabled && value !== null && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_DIALOG_TITLE_EDIT", defaultMessage: "\u00DAprava" })),
        !disabled && value === null && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_DIALOG_TITLE_ADD", defaultMessage: "P\u0159id\u00E1n\u00ED" }))));
    return (react_1.default.createElement(dialog_1.Dialog, { ref: dialogRef, title: title, showConfirm: !disabled, confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_BTN_SAVE", defaultMessage: "Ulo\u017Eit" }), onConfirm: handleSave, disableBackdrop: true }, () => (react_1.default.createElement(form_1.Form, { editing: !disabled, initialValues: value !== null && value !== void 0 ? value : initNewItem(), onSubmit: handleSubmit, ref: ref, validationSchema: validationSchema },
        react_1.default.createElement(FormFieldsComponent, { initialValue: value })))));
});
//# sourceMappingURL=table-field-dialog.js.map